import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { doPromiseAll } from '../../../config/core.promise-utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../services/core.translate.service';
import { UserRest } from '../../../services/core.user.rest.service';
import { ProjectService } from '../../../services/project.service';
import { LegacyKanbanService } from '../../../services/core.legacy-kanban.service';
import { UiService } from '../../../services/core.ui.service';
import { NotificationService } from '../../../services/core.notification.service';
import { UserService } from '../../../services/core.user.service';

import { GfTitleService } from '../../../services/core.title.service';

import * as _ from 'lodash';
import { TrackeritemEditModalComponent } from '../../../../plugins/tracker/edit/trackerItemEditModal/trackeritem.edit.modal.component';

@Component({
    selector: 'project-standup',
    template: require('./project.standup.component.html')
})
export class ProjectStandupComponent implements OnInit, OnDestroy {

    @Input() project: any = null;

    @Input() projectMenu: any = null;

    private unixName = '';
    private options: any = {};
    protected breadcrumbs = [];

    protected user: any;
    protected members = [];
    protected member = {
        membersFData: ''
    };
    protected membersPageSize = 20;
    protected membersPage = 1;

    protected trackerItems = [];
    protected trackerItemsPageSize = 10;
    protected trackerItemsPage = 1;
    protected trackerItemsAmount = 0;

    protected activity = [];
    protected activityPageSize = 20;
    protected activityPage = 1;
    private activityAmount = 0;

    protected queue = [];
    protected queuePageSize = 10;
    protected queuePage = 1;
    protected queueAmount = 0;

    private expandedAct = [];
    private username = null;

    protected allLoad = false;
    protected loading = true;

    protected view = 'project';

    private filterMembersPromise = null;

    protected drag;

    constructor(
        private projectService: ProjectService,
        private kanbanService: LegacyKanbanService,
        private uiService: UiService,
        private $window: Window,
        private userRest: UserRest,
        private gfTranslateService: GfTranslateService,
        private stateService: StateService,
        private userService: UserService,
        private modalService: NgbModal,
        private notificationService: NotificationService,
        private titleService: GfTitleService
    ) { }

    ngOnInit() {

        this.resetDrag();

        this.unixName = this.stateService.params.unixName;           // What project are we on?

        this.options = {
            unixName: this.unixName,
            user: this.stateService.params.user,
            querystring: 'page_size=50'
        };

        this.breadcrumbs = [
            {
                label: _.get(this.project, 'name', ''),
                state: 'home.project.summary',
                params: { unixName: _.get(this.project, 'unixName', '') }
            },
            {
                label: this.gfTranslateService.translate('Team Standup')
            }
        ];

        this.titleService.setTitle(this.project.name, 'Team Standup');

        this.members = [];
        this.membersPageSize = _.get(this.stateService.params, 'membersPageSize', 20);
        this.membersPage = _.get(this.stateService.params, 'membersPage', 1);
        this.trackerItemsPageSize = 10;
        this.trackerItemsPage = 1;
        this.trackerItemsAmount = 0;

        this.activityPageSize = 20;
        this.activityPage = 1;
        this.activityAmount = 0;

        this.queuePageSize = 10;
        this.queuePage = 1;
        this.queueAmount = 0;

        this.expandedAct = [];
        this.username = null;

        this.allLoad = false;
        this.loading = true;

        this.view = _.get(this.stateService.params, 'view', 'project');

        this.gfTranslateService.setStrings('es', {
            'There was a problem loading project members': 'Hubo un problema al cargar los miembros del proyecto',
            'There was a problem adding items to the To-Do': 'Hubo un problema al añadir items a la cola de trabajo',
            'There was a problem removing items from the To-Do': 'Hubo un problema al quitar items de la cola de trabajo',
            'You are not allowed to add items to {{unixname}} To-Do': 'No estas autorizado a añadir items a la cola de trabajo de {{unixname}}',
            'You are not allowed to remove items from {{unixname}} To-Do': 'No estas autorizado a quitar cosas desde la cola de trabajo de {{unixname}}',
            'There was a problem loading assigned items': 'Hubo un problema al cargar los items assignados',
            'There was a problem loading activity': 'Hubo un problema al cargar los registros de actividad',
            'There was a problem loading To-Do': 'Hubo un problema al cargar la cola de trabajo',
            'Not Allowed': 'No permitido'
        });

        this.loadProjectMembers()
            .then(() => {
                this.username = this.stateService.params?.user;

                if (_.isEmpty(this.username) || (this.username == 'None')) {
                    this.username = this.userService.session.getUnixName();
                }

                this.loadData();
            });

        this.notificationService.subscribe('standup', 'queue-change', (data) => {
            this.queue = _.get(data, 'queue', this.queue);
            this.trackerItems = _.get(data, 'todoList', this.trackerItems);
            this.queueAmount = _.get(this, 'queue.length', 0);
            this.trackerItemsAmount = _.get(this, 'trackerItems.length', 0);
        });
    }

        ngOnDestroy() {
            this.notificationService.unsubscribe('standup');
        }

    //Public Methods
    selectUser(u) {
        this.options = {
            unixName: u.unixName
        };

        this.username = u.unixName;

        this.refreshData();
    }

    scheduleFilterMembers() {
        if (this.filterMembersPromise) {
            this.$window.clearTimeout(this.filterMembersPromise);
        }

        this.filterMembersPromise = this.$window.setTimeout(this.filterMembers, 250, false);
    };

    changePage(group, number) {
        switch (group) {
            case 'queue':
                this.queuePage = number;
                this.loadQueue();
                break;

            case 'members':
                this.membersPage = number;
                this.loadProjectMembers();
                break

            case 'assignees':
                this.trackerItemsPage = number;
                this.loadTrackerItems();
                break;

            case 'activity':
                this.activityPage = number;
                this.loadActivity();
                break;

            default:
        }
    }

    changeActivityPage(params) {
        this.activityPageSize = params.pageSize;
        this.activityPage = params.pageNum;
        this.loadActivity();
    }

    setPageSize(group, size) {
        switch (group) {
            case 'queue':
                this.queuePageSize = size;
                this.queuePage = 1;
                this.loadQueue();
                break;

            case 'members':
                this.membersPageSize = size;
                this.membersPage = 1;
                this.loadProjectMembers();
                break

            case 'assignees':
                this.trackerItemsPageSize = size;
                this.trackerItemsPage = 1;
                this.loadTrackerItems();
                break;

            case 'activity':
                this.activityPageSize = size;
                this.activityPage = 1;
                this.loadActivity();
                break;

            default:
        }
    };

    filterMembers() {
        this.member.membersFData = _.get(this.member, 'membersFData', '');
        return this.projectService.members(
            this.unixName,
            {
                page_size: this.membersPageSize,
                group: true,
                type: 'standup',
                search: this.member.membersFData
            }
        ).then((response: any) => {
            this.members = response.items;
            this.membersPage = 1;
        }, () => {
            var msg = this.gfTranslateService.translate('There was a problem loading project members');
            this.uiService.message.showWarning(msg, 'Data Error');
        });
    };

    // NOTE: Yes, these results are backwards.
    // It's also wired into the user timeline component, so it has to stay this way for now.
    isNextPage(group) {
        switch (group) {
            case 'assignees':
                return this.trackerItemsAmount < this.trackerItemsPageSize;
            case 'activity':
                return this.activityAmount < this.activityPageSize;
            case 'queue':
                return this.queueAmount < this.queuePageSize;
        }
    }

    hasNextPage() {
        return this.activityAmount < this.activityPageSize;
    }

    // NOTE: Yes, these results are backwards.
    // It's also wired into the user timeline component, so it has to stay this way for now.
    showQtyDropdown(group) {
        switch (group) {
            case 'assignees':
                return this.trackerItemsAmount < 10;

            case 'queue':
                return this.queueAmount < 10;
        }
    }

    addToQueue(item, index) {
        if (!this.kanbanService.isAllowedToUpdate(
            this.username, _.get(this, 'projectMenu.admin', false)
        )) {
            this.kanbanService.notAllowedMessage('add');
            return false;
        }
        this.kanbanService.addToQueue(this.username, this.trackerItems, this.queue, item, index);
    };

    removeFromQueue(item, index) {
        if (!this.kanbanService.isAllowedToUpdate(
            this.username, _.get(this, 'projectMenu.admin', false)
        )) {
            this.kanbanService.notAllowedMessage('remove');
            return false;
        }

        this.kanbanService.removeFromQueue(
            this.username, this.trackerItems, this.queue, item, index
        );
    };

    expandActivity(actId) {
        var expandedObject = { id: actId };
        if (_.find(this.expandedAct, expandedObject) === undefined)
            this.expandedAct.push(expandedObject);
        else
            _.remove(this.expandedAct, expandedObject);
    }

    isExpanded(actId) {
        return (_.find(this.expandedAct, { id: actId }));
    }

    setView(viewName) {
        this.view = viewName;
        this.refreshData();
    };

    showQuickEdit(event, trackeritem) {
        event.stopPropagation();
        event.preventDefault();

        const modalRef = this.modalService.open(TrackeritemEditModalComponent);
        modalRef.componentInstance.trackeritem = trackeritem;
        modalRef.componentInstance.tracker = trackeritem.tracker;
        modalRef.componentInstance.allowUpdate = _.get(this.project, 'rel.permissions.trackers[' + trackeritem.tracker.id + '].canUpdate', false);
        modalRef.componentInstance.allowAssignments = _.get(this.project, 'rel.permissions.trackers[' + trackeritem.tracker.id + '].canAssign', false);
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.refreshData();
        });
    };

    goToTrackeritem(ti) {
        this.stateService.go('home.project.summary.tracker.item.edit', { id: ti.id, tracker: ti.tracker.id, unixName: ti.tracker.project.unixName }, { reload: true });
    };

    //Internal Methods
    refreshData() {
        this.allLoad = false;

        this.trackerItems = null;
        this.queue = null;
        this.activity = null;

        this.trackerItemsPage = 1;
        this.queuePage = 1;
        this.activityPage = 1;

        if (this.username && this.username != 'None') {
            this.loadData();
        }
        this.options.user = this.username;
    }

    loadProjectMembers() {
        this.loading = true;
        const params = {
            page_size: this.membersPageSize,
            page_num: this.membersPage,
            group: true,
            type: 'standup'
        };

        return new Promise((resolve, reject) => {
            this.projectService.members(this.unixName, params)
                .then((response: any) => {
                    this.loading = false;
                    this.members = response.items;
                    resolve(response);
                })
                .catch(() => {
                    this.loading = false;
                    var msg = this.gfTranslateService.translate('There was a problem loading project members', { 'unixName': this.unixName });
                    this.uiService.message.showWarning(msg, 'Data Error');
                    reject();
                });

        });
    }

    loadData() {
        var promises = {
            user: this.userRest.getBasic(this.username)
        };

        if (this.view != 'all') {
            promises['trackerItems'] = this.userRest.getTrackerItems(this.username, { page_size: this.trackerItemsPageSize, page_num: this.trackerItemsPage, projects: this.project.id, queue: false });
            promises['queue'] = this.userRest.getQueue(this.username, { page_size: this.queuePageSize, page_num: this.queuePage, project: this.project.unixName });
            promises['activity'] = this.userRest.getUserActivity(this.username, { max: this.activityPageSize, page_num: this.activityPage, startDate: '1970', endDate: 'now', project: this.project.unixName });
        } else {
            promises['trackerItems'] = this.userRest.getTrackerItems(this.username, { page_size: this.trackerItemsPageSize, page_num: this.trackerItemsPage, queue: false });
            promises['queue'] = this.userRest.getQueue(this.username, { page_size: this.queuePageSize, page_num: this.queuePage });
            promises['activity'] = this.userRest.getUserActivity(this.username, { max: this.activityPageSize, page_num: this.activityPage, startDate: '1970', endDate: 'now' });
        }

        doPromiseAll(promises)
            .then((data) => {
                this.user = data?.user ?? null;

                this.trackerItems = _.sortBy(
                    _.get(data, 'trackerItems.items', []),
                    ['priority']
                );
                this.trackerItemsAmount = _.get(data, 'trackerItems.paging.count', 0);

                this.activity = _.orderBy(
                    _.get(data, 'activity.items', []),
                    ['date'],
                    ['desc']
                );
                this.activityAmount = _.get(data, 'activity.paging.count', 0);

                this.queue = _.get(data, 'queue.items', []);
                this.queueAmount = _.get(data, 'queue.paging.count', 0);
            })
            .catch(() => {
                var msg = this.gfTranslateService.translate('There was a problem loading data');
                this.uiService.message.showWarning(msg, 'Data Error');
            }).finally(() => {
                this.allLoad = true;
            });
    }

    loadTrackerItems() {
        this.trackerItems = null;
        var params: any = {
            page_size: this.trackerItemsPageSize,
            page_num: this.trackerItemsPage,
            queue: false
        };

        if (this.view != 'all') {
            params.projects = this.project.id;
        }

        this.userRest.getTrackerItems(this.username, params)
            .then((result: any) => {
                this.trackerItems = result.items;
                this.trackerItemsAmount = result.paging.count;
            })
            .catch(() => {
                var msg = this.gfTranslateService.translate('There was a problem loading assigned items');
                this.uiService.message.showWarning(msg, 'Data Error');
            });
    }

    loadActivity() {
        this.activity = null;
        var params: any = {
            max: this.activityPageSize,
            page_num: this.activityPage,
            startDate: '1970',
            endDate: 'now'
        };

        if (this.view != 'all') {
            params.project = this.project.unixName;
        }

        this.userRest.getUserActivity(this.username, params)
            .then((resource: any) => {
                this.activity = resource.items;
                this.activityAmount = resource.paging.count;
            })
            .catch(() => {
                var msg = this.gfTranslateService.translate('There was a problem loading activity');
                this.uiService.message.showWarning(msg, 'Data Error');
            });
    }

    loadQueue() {
        this.queue = null;
        this.userRest.getQueue(this.username, { page_size: this.queuePageSize, page_num: this.queuePage })
            .then((result: any) => {
                this.queue = result.items;
                this.queueAmount = result.paging.count;
            },
                () => {
                    var msg = this.gfTranslateService.translate('There was a problem loading To-Do');
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
            );
    }

    /**
     * Called while dragging over a valid drop zone.
     * Calculates the target drop index and pixel Y position for the indicator.
     */
    onDragOver(event: DragEvent, target: 'todo' | 'doing'): void {
        if (!this.drag.item) return;
        event.preventDefault();

        this.drag.target = target;

        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'move';
        }

        const container = event.currentTarget as HTMLElement;
        const cards = Array.from(container.querySelectorAll('.kanban-card'));
        let dropIndex = cards.length;

        for (let i = 0; i < cards.length; i++) {
            const rect = cards[i].getBoundingClientRect();
            if (rect.height === 0) continue;
            const midY = rect.top + rect.height / 2;
            if (event.clientY < midY) {
                dropIndex = i;
                break;
            }
        }

        this.drag.targetIndex = dropIndex;

        // Calculate pixel position for the absolutely-positioned indicator
        const containerRect = container.getBoundingClientRect();
        let indicatorY = 0;

        if (cards.length === 0) {
            indicatorY = 8;
        } else if (dropIndex === 0) {
            // Just above the first card
            const firstTop = cards[0].getBoundingClientRect().top;
            indicatorY = firstTop - containerRect.top + container.scrollTop - 4;
        } else if (dropIndex < cards.length) {
            // Between card[dropIndex-1] and card[dropIndex]
            const prevBottom = cards[dropIndex - 1].getBoundingClientRect().bottom;
            const nextTop = cards[dropIndex].getBoundingClientRect().top;
            indicatorY = ((prevBottom + nextTop) / 2) - containerRect.top + container.scrollTop - 2;
        } else {
            // After the last card
            const lastBottom = cards[cards.length - 1].getBoundingClientRect().bottom;
            indicatorY = lastBottom - containerRect.top + container.scrollTop + 4;
        }

        this.drag.indicatorY = indicatorY;
    }

    /**
     * Called when the cursor leaves a drop zone container.
     * Clears the indicator only when truly leaving the container.
     */
    onDragLeave(event: DragEvent, column: 'todo' | 'doing'): void {
        const container = event.currentTarget as HTMLElement;
        const related = event.relatedTarget as HTMLElement;
        if (!related || !container.contains(related)) {
            if (this.drag.target === column) {
                this.drag.target = null;
                this.drag.targetIndex = -1;
            }
        }
    }

    /**
     * Returns true if the drop indicator should be visible for the given column.
     */
    isIndicatorVisible(column: string): boolean {
        if (!this.drag.item || this.drag.target !== column || this.drag.targetIndex < 0) {
            return false;
        }

        // For same-column reordering, suppress indicator at no-op positions
        if (this.drag.source === column) {
            const list = (column === 'doing') ? this.queue : this.trackerItems;
            const dragIndex = list.indexOf(this.drag.item);
            if (dragIndex >= 0 && (this.drag.targetIndex === dragIndex || this.drag.targetIndex === dragIndex + 1)) {
                return false;
            }
        }

        return true;
    }

    onDragEnd(event: DragEvent): void {
        event.stopPropagation();
        this.resetDrag();
    }

    onDragStart(event: DragEvent, item: any, source: 'todo' | 'doing'): void {
        this.drag.item = item;
        this.drag.source = source;
        if (event.dataTransfer) {
            event.dataTransfer.setDragImage(event.currentTarget as any, 0, 0);
            event.dataTransfer.setData('text', String(item.id));
            event.dataTransfer.effectAllowed = 'move';
        }
    }

    /**
     * Called when the dragged item is dropped in a valid drop zone.
     * We have to check the source and target to decide if we are adding or removing from queue,
     * or if we are reordering within the same column.
     */
    onDrop(event: DragEvent, target: 'todo' | 'doing'): void {
        event.preventDefault();

        if (!this.drag.item || !this.drag.source) {
            event.dataTransfer && (event.dataTransfer.effectAllowed = 'none');
            return;
        }

        const dropIndex = this.drag.targetIndex >= 0 ? this.drag.targetIndex : 0;

        // Cross-column: dropping on "To-Do" from "Doing" — remove from queue
        if (target === 'todo' && this.drag.source === 'doing') {
            const idx = this.queue.indexOf(this.drag.item);
            if (idx > -1) {
                this.removeFromQueue(this.drag.item, dropIndex);
            }
        }
        // Cross-column: dropping on "Doing" from "To-Do" — add to queue
        else if (target === 'doing' && this.drag.source === 'todo') {
            this.addToQueue(this.drag.item, dropIndex);
        }
        // Same-column reorder in "Doing" — reorder queue
        else if (target === 'doing' && this.drag.source === 'doing') {
            this.addToQueue(this.drag.item, dropIndex);
        }
        // Same-column reorder in "To-Do" — local reorder only
        else if (target === 'todo' && this.drag.source === 'todo') {
            const currentIndex = this.trackerItems.indexOf(this.drag.item);
            if (currentIndex > -1 && currentIndex !== dropIndex) {
                this.trackerItems.splice(currentIndex, 1);
                let adjustedIndex = dropIndex;
                if (currentIndex < dropIndex) adjustedIndex--;
                this.trackerItems.splice(adjustedIndex, 0, this.drag.item);
            }
        }

        // Reset the drag placeholders
        this.resetDrag();
    }

    resetDrag() {
        this.drag = {
            item: null,
            source: null,
            target: null,
            targetIndex: -1,
            indicatorY: 0
        };
    }
}
